"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dateLength = 8;
/**
 * a utility to transform ISO/JS date string to YYYYMMDD format
 */
exports.default = (isoDate) => {
    const date = new Date(isoDate);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTime#return_value
    // date.getTime() returns NaN for invalid date strings
    if (isNaN(date.getTime())) {
        return undefined;
    }
    return date
        .toISOString()
        .replace(/[-T:.Z]/g, '')
        .slice(0, dateLength);
};
//# sourceMappingURL=dateFormat.js.map